// DCF 채팅 수식 렌더 — 바닐라 dcf.html 의 KaTeX 0.16 CDN(katex + auto-render)과
// dcf.js renderMath() 이식. echarts(vachart.ts)처럼 dynamic import 로 코드
// 스플리팅해 수식이 실제로 등장할 때만 katex 청크·CSS 를 로드한다.
import type renderMathInElementFn from "katex/contrib/auto-render";

type AutoRender = typeof renderMathInElementFn;

let autoRenderPromise: Promise<AutoRender | null> | null = null;

/** katex + auto-render + css 지연 로드 (실패 시 null — 수식 렌더만 조용히 생략) */
function loadAutoRender(): Promise<AutoRender | null> {
  if (!autoRenderPromise) {
    autoRenderPromise = Promise.all([
      import("katex/contrib/auto-render"),
      import("katex/dist/katex.min.css"),
    ])
      .then(([m]) => m.default)
      .catch(() => null);
  }
  return autoRenderPromise;
}

/** 수식 구분자 존재 여부 — katex 청크를 로드할지 게이트.
 *  \( \[ 또는 짝이 맞는 $…$ 가 있어야 true ($100 같은 단독 통화 표기는 제외) */
export function hasMathDelimiters(text: string): boolean {
  if (!text) return false;
  if (text.includes("\\(") || text.includes("\\[")) return true;
  const i = text.indexOf("$");
  return i >= 0 && text.indexOf("$", i + 1) > i;
}

/** 바닐라 dcf.js renderMath(el) — delimiters/옵션 동일 */
export async function renderMathIn(el: HTMLElement): Promise<void> {
  const render = await loadAutoRender();
  if (!render) return;
  try {
    render(el, {
      delimiters: [
        { left: "$$", right: "$$", display: true },
        { left: "\\[", right: "\\]", display: true },
        { left: "$", right: "$", display: false },
        { left: "\\(", right: "\\)", display: false },
      ],
      throwOnError: false,
      ignoredClasses: ["chat-table"],
    });
  } catch {
    /* 바닐라와 동일 — 수식 렌더 실패는 본문 표시에 영향 주지 않음 */
  }
}
